import { GridColDef } from '@mui/x-data-grid';
import { Dataset } from '~/api/types';
import TruncatedCell from '~/components/Table/components/TruncatedCell';
import { formatSizeGb } from '~/utils';
import { AccessApprovalStatusCell, ActionsCell, AnatomyCell, DatasetNameCell, DatasetStatusCell } from '.';

const columns: GridColDef<Dataset>[] = [
  {
    field: 'name',
    headerName: 'Dataset name',
    flex: 1.1,
    minWidth: 122,
    renderCell: (params) => (
      <DatasetNameCell name={params.row.name} description={params.row.description} id={params.row.id} />
    ),
  },
  {
    field: 'status',
    flex: 0.5,
    headerName: 'Dataset status',
    minWidth: 85,
    renderCell: (params) => <DatasetStatusCell status={params.row.status} deidentified={params.row.de_identified} />,
  },
  {
    field: 'data_format',
    flex: 1.1,
    minWidth: 110,
    headerName: 'Data source type',
    renderCell: (params) => <TruncatedCell value={params.row.data_format?.join(', ') || '—'} />,
  },
  {
    field: 'collection_source',
    flex: 1.2,
    headerName: 'Data source category',
    minWidth: 110,
    renderCell: (params) => <TruncatedCell value={params.row?.collection_source || '—'} />,
  },
  {
    field: 'size',
    headerName: 'Size (GB)',
    flex: 0.5,
    minWidth: 90,
    align: 'center',
    valueGetter: (_, row) => formatSizeGb(row.size),
  },
  {
    field: 'anatomy',
    headerName: 'Anatomy',
    flex: 0.9,
    minWidth: 90,
    renderCell: (params) => <AnatomyCell anatomy={params.row.anatomy?.join(', ') || '—'} />,
  },
  {
    field: 'modality',
    headerName: 'Modality',
    minWidth: 90,
    renderCell: (params) => <TruncatedCell value={params.row?.modality?.join(', ') || '—'} />,
    flex: 0.9,
  },
  {
    field: 'source_ou',
    headerName: 'OU owner',
    flex: 1,
    minWidth: 97,
    renderCell: (params) => <TruncatedCell value={params.row?.source_ou || '—'} />,
  },
  {
    field: 'access_approval',
    flex: 1,
    minWidth: 77,
    headerName: 'Access status',
    renderCell: (params) => <AccessApprovalStatusCell accessStatus={params.row.access_status} />,
  },
  {
    field: 'actions',
    sortable: false,
    headerName: 'Actions',
    flex: 0.6,
    minWidth: 75,
    renderCell: (params) => <ActionsCell datasetInfo={params.row} />,
  },
];

export default columns;
